import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { AnimatableColor } from "../AnimatableColor";
import { setRangeValue } from "../../../Utils/NumberUtils";
export var Stroke = /*#__PURE__*/function () {
  function Stroke() {
    _classCallCheck(this, Stroke);

    this.width = 0;
  }

  _createClass(Stroke, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.color !== undefined) {
        this.color = AnimatableColor.create(this.color, data.color);
      }

      if (data.width !== undefined) {
        this.width = setRangeValue(data.width);
      }

      if (data.opacity !== undefined) {
        this.opacity = setRangeValue(data.opacity);
      }
    }
  }]);

  return Stroke;
}();